import { render, staticRenderFns } from "./FieldDetailTemplate.vue?vue&type=template&id=b0b64578&scoped=true"
import script from "./FieldDetailTemplate.vue?vue&type=script&lang=js"
export * from "./FieldDetailTemplate.vue?vue&type=script&lang=js"
import style0 from "./FieldDetailTemplate.vue?vue&type=style&index=0&id=b0b64578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b64578",
  null
  
)

export default component.exports